import { render, staticRenderFns } from "./insertEvent.vue?vue&type=template&id=ffd34448"
import script from "./insertEvent.vue?vue&type=script&lang=js"
export * from "./insertEvent.vue?vue&type=script&lang=js"
import style0 from "./insertEvent.vue?vue&type=style&index=0&id=ffd34448&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports